/**
 * Catalog of Agentic AI use cases and architecture write-ups.
 * Add new entries here — they appear on the Agentic AI section.
 * Published items need a matching article in UseCasePost ARTICLES.
 */
export const agenticUseCases = [
  {
    id: 1,
    slug: 'dense-form-assistant-mcp',
    status: 'published',
    title: 'An AI Assistant for a web application Hundreds of Fields with Ask, Edit modes',
    excerpt:
      'How an in-app assistant can explain a dense, multi-tab form and update it safely: separate query and mutation MCP servers, deterministic database writes, and structured results back to the UI.',
    readTime: '7 min read',
    tags: ['Agentic AI', 'MCP', 'Architecture'],
    hero: {
      titleLine1: 'An Assistant for',
      titleLine2Italic: 'Hundreds of Fields',
      subtitle:
        'Ask mode explains a dense multi-tab form. Edit mode updates it. Two MCP servers keep reads, writes, and the database deterministic.',
      metaLine: '7 min read · Architecture · MCP',
    },
  },
];

export function getUseCaseByIdentifier(identifier) {
  if (identifier == null || identifier === '') return undefined;
  const s = String(identifier).trim();
  if (/^\d+$/.test(s)) {
    return agenticUseCases.find((u) => String(u.id) === s);
  }
  return agenticUseCases.find((u) => u.slug === s);
}
